import type { IActiveBudget, IActiveBudgetTransaction, IBudgetTree, IVBudget } from '@/types/budget';
import { request } from './client';
import type { QueryParams, RequestOptions } from './client';

export function fetchActiveBudget(
  params: QueryParams = {},
  requestOptions: RequestOptions = {}
): Promise<{ data: IActiveBudget | null }> {
  return request('GET', '/v1/account/active-budget', params, undefined, requestOptions);
}
export function fetchActiveBudgetTransactions(params: QueryParams = {}): Promise<{ data: IActiveBudgetTransaction[] }> {
  return request('GET', '/v1/account/active-budget/transactions', params);
}

export function fetchBudgetTree(customerBudgetId: number, params: QueryParams = {}): Promise<{ data: IBudgetTree }> {
  return request('GET', `/v1/account/budgets/${customerBudgetId}/vbudgets/tree`, params);
}

export function createVBudget(customerBudgetId: number, data: Partial<IVBudget>): Promise<{ data: IVBudget }> {
  return request('POST', `/v1/account/budgets/${customerBudgetId}/vbudgets`, {}, data);
}

export function updateVBudget(
  customerBudgetId: number,
  vBudgetId: number,
  data: Partial<IVBudget>
): Promise<{ data: IVBudget }> {
  return request('PUT', `/v1/account/budgets/${customerBudgetId}/vbudgets/${vBudgetId}`, {}, data);
}

export function deleteVBudget(customerBudgetId: number, vBudgetId: number) {
  return request('DELETE', `/v1/account/budgets/${customerBudgetId}/vbudgets/${vBudgetId}`);
}

export function suggestVBudget(
  customerBudgetId: number,
  companyId: number,
  productId: number
): Promise<{ vbudget_id: number | null }> {
  return request('GET', `/v1/account/budgets/${customerBudgetId}/vbudgets/suggest`, {
    company_id: companyId,
    product_id: productId,
  });
}
